module.exports = __webpack_public_path__ + "images/emoji/currency_exchange.89caadd00c82f7dd9b90.png";